import * as React from 'react';
import { Header3 } from '@cian/ui-kit';
import { IPromoBank } from '../../../../types/newbuilding/promos';
import { BankItem } from '../BankItem';

import * as styles from './BanksList.css';

interface IBanksListProps {
  banks: IPromoBank[];
  onMortgageClick?(): void;
}

export function BanksList({ banks, onMortgageClick }: IBanksListProps) {
  return (
    <>
      <div className={styles['title']}>
        <Header3>Банки</Header3>
      </div>
      <ul className={styles['container']}>
        {banks.map(bank => (
          <li key={bank.id} className={styles['item']}>
            <BankItem bank={bank} onMortgageClick={onMortgageClick} />
          </li>
        ))}
      </ul>
    </>
  );
}
